/* src/app/modules/taxes/model-193/model-193.component.css */
:host {
  --m193-brand: #e3fd64;
  --m193-brand-d: #4d7a00;
  --m193-brand-bg: rgba(227, 253, 100, 0.08);
  --m193-text: #1a1d23;
  --m193-muted: #6b7280;
  --m193-border: #e5e7eb;
  --m193-surface: #ffffff;
  --m193-radius: 10px;
  --m193-shadow: 0 2px 8px rgba(0,0,0,0.07);
  display: block;
}
.m193-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 0 auto;
}
.m193-header {
  display: flex;
  align-items: center;
  gap: 14px;
}
.m193-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: var(--m193-brand-bg);
  flex-shrink: 0;
}
.m193-header__icon mat-icon {
  font-size: 26px;
  width: 26px;
  height: 26px;
  color: var(--cf-brand-dark);
}
.m193-header__title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: var(--m193-text);
  line-height: 1.2;
}
.m193-header__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--m193-muted);
}
.m193-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.m193-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px !important;
}
.m193-alerts {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.m193-alert {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  background: rgba(227, 253, 100, 0.1);
  border: 1px solid rgba(227, 253, 100, 0.4);
  border-left: 4px solid var(--m193-brand);
  border-radius: var(--m193-radius);
}
.m193-alert__text {
  font-size: 13px;
  color: var(--m193-text);
}
.m193-alert__link {
  font-size: 12px;
  font-weight: 600;
  color: var(--m193-brand-d);
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
  background: none;
  border: none;
  padding: 0;
}
.m193-alert__link:hover {
  text-decoration: underline;
}
.m193-card {
  background: var(--m193-surface);
  border: 1px solid var(--m193-border);
  border-radius: var(--m193-radius);
  box-shadow: var(--m193-shadow);
  overflow: hidden;
}
.m193-card__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: var(--m193-brand);
}
.m193-card__head mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--m193-brand-d);
  opacity: 0.9;
}
.m193-card__head-label {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--m193-brand-d);
}
.m193-card__body {
  padding: 16px;
}
.m193-subhead {
  display: block;
  background: var(--m193-brand);
  color: var(--m193-brand-d);
  padding: 8px 12px;
  font-weight: 600;
  font-size: 13px;
  border-radius: 6px;
  margin: 4px 0 10px;
}
.m193-card__body .form-control {
  border: 1px solid var(--m193-border);
  border-radius: 6px;
  font-size: 13px;
  padding: 6px 10px;
  color: var(--m193-text);
  background: #fff;
}
.m193-card__body .form-control:focus {
  outline: none;
  border-color: var(--m193-brand);
  box-shadow: 0 0 0 2px rgba(227, 253, 100, 0.35);
}
.m193-card__body > .container > .row > [class*=col-] > span,
.m193-card__body span {
  font-size: 12px;
  color: var(--m193-muted);
  display: block;
  margin-bottom: 2px;
}
.m193-card__body table.table {
  font-size: 13px;
}
.m193-card__body .mat-mdc-tab-body-content {
  overflow-x: hidden;
}
.m193-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 48px 24px;
}
.m193-loading p {
  margin: 0;
  font-size: 14px;
  color: var(--m193-muted);
}
/*# sourceMappingURL=model-193.component.css.map */
